import { render, staticRenderFns } from "./BackbeatView.vue?vue&type=template&id=225f1af2&scoped=true"
import script from "./BackbeatView.vue?vue&type=script&lang=js"
export * from "./BackbeatView.vue?vue&type=script&lang=js"
import style0 from "./BackbeatView.vue?vue&type=style&index=0&id=225f1af2&prod&lang=scss&scoped=true"
import style1 from "./BackbeatView.vue?vue&type=style&index=1&id=225f1af2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "225f1af2",
  null
  
)

export default component.exports